import {mapValues, omit, difference, keys, keyBy, createReducer} from 'helpers';
import {RootState, Actions} from 'store/types';
import * as actions from '../actions/actions';
import {ServerActions} from 'store/server';

export const index = createReducer<RootState['notes']['index'], Actions<typeof actions> | ServerActions>({}, {
  NOTES_UPDATE(state, {note, category, timestamp_today}) {
    return {
      ...state,
      [note.id]: {
        ...note,
        date: note.date ?? timestamp_today,
        category: category.predefined ? category.id : '',
        categoryId: category.predefined ? '' : category.id
      }
    };
  },

  NOTES_TEXT_UPDATE: (state, {id, text}) => {
    const note = state[id];
    if (note) {
      return {
        ...state,
        [note.id]: {
          ...note,
          text
        }
      };
    }
    return state;
  },

  NOTES_CATEGORY_DELETE: (state, {id}) => {
    return mapValues(state, note => ({
      ...note,
      category: id === note.categoryId ? 'note' : note.category,
      categoryId: id === note.categoryId ? '' : note.categoryId
    }));
  },

  NOTES_DELETE: (state, {id}) => {
    return omit(state, id);
  },

  NOTES_CATEGORY_UPDATE: (state) => state,

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.notes);
    if (action.notes.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.notes, 'id')
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: () => ({}),
});
